module.exports = __webpack_public_path__ + "static/media/banner-left.88893c37.svg";